import {calculateStagePrice} from './marketPricing';

export function estimatePreview(item,type,destination){
  if(item.amountMode)return amountPreview(item);
  const values=item.manual;
  if(!values)return item.details||null;
  const valid=(key,min=0)=>values[key]!==''&&values[key]!=null&&Number.isFinite(Number(values[key]))&&Number(values[key])>=min;
  let selling=null;
  if(valid('cost')&&valid('mrp',0.01)&&valid('margin')&&valid('factor',0.001)&&valid('discount')&&Number(values.discount)<100&&Number(values.margin)<=1000&&Number(values.factor)<=100){
    const context={destination_type:type,dispatch_to_id:destination||null};
    const price=calculateStagePrice({purchaseCost:Number(values.cost),fixedMrp:Number(values.mrp),context,ledgers:[{...context,margin_percent:Number(values.margin),proportion_factor:Number(values.factor),discount_percent:Number(values.discount),is_active:true}]});
    selling=values.selling!==''&&values.selling!=null?(valid('selling')&&Number(values.selling)<=Number(values.mrp)?Number(values.selling):null):price?.price??null;
  }
  const qty=Number(item.qty);
  return {...item.details,selling,total:selling!=null&&Number.isFinite(qty)&&qty>0?Math.round(qty*selling*100)/100:null,shortfall:valid('stock')?Math.max(0,qty-Number(values.stock)):0};
}

// Rows priced by an amount the user typed (new products, or packs with no saved financials).
export function amountPreview(item){
  const qty=Number(item.qty),amount=Number(item.amount),mrp=Number(item.amountMrp);
  const amountOk=item.amount!==''&&item.amount!=null&&Number.isFinite(amount)&&amount>0;
  const mrpOk=item.amountMrp!==''&&item.amountMrp!=null&&Number.isFinite(mrp)&&mrp>0;
  const selling=amountOk&&(!mrpOk||amount<=mrp)?amount:null;
  const stock=item.details?.stock;
  return {...item.details,amountEntered:true,custom:Boolean(item.custom),selling,mrp:mrpOk?mrp:selling,
    error:!amountOk?'Enter the amount per pack':mrpOk&&amount>mrp?'Amount cannot exceed MRP':null,
    total:selling!=null&&Number.isFinite(qty)&&qty>0?Math.round(qty*selling*100)/100:null,
    shortfall:Number.isFinite(Number(stock))&&stock!==''&&stock!=null?Math.max(0,qty-Number(stock)):0};
}
